import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { JedsMenuService } from "@shared/services/app/menu.service";
import { environment } from "environments/environment";
import {
  ComponentType,
  ConnectedPosition,
  Overlay,
  OverlayRef,
} from "@angular/cdk/overlay";
import { MatButton } from "@angular/material/button";
import { Router } from "@angular/router";
import { isArray } from "lodash";
import Swal from "sweetalert2";
import { LOG } from "../err/Logger";
import { MatSort, Sort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { ViewLogComponent } from "../view-log/view-log.component";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-tabla-automatica",
  templateUrl: "./tabla-automatica.component.html",
  styleUrls: ["./tabla-automatica.component.scss"],
})
export class TablaAutomaticaComponent implements OnInit {
  constructor(
    private router: Router,
    private menuService: JedsMenuService,
    private dialog: MatDialog
  ) {}

  @Input() dataSource: MatTableDataSource<any>;
  @Input() headerDef = [];
  @Input() matDefs = [];
  @Input() matHeaderRowDefs = [];
  @Input() urlId = "";
  @Input() permisos;
  @Input() service: any = "";
  @Input() serviceName = "";
  @Input() edit: ComponentType<any> | null = null;

  @Output() sortListado = new EventEmitter<{ sortString: string }>();
  @Output() uploadData = new EventEmitter<any>();
  @ViewChild(MatSort) sort!: MatSort;
  sortSSP: string = ``;
  urlUploads = environment.urlUpload;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe((sort: Sort) => {
      let column = sort.active;
      switch (sort.direction) {
        case "asc":
          this.sortSSP = `=${column}`;
          break;
        case "desc":
          this.sortSSP = `=-${column}`;
          break;
        default:
          this.sortSSP = "";
          break;
      }
      this.sortListado.emit({ sortString: this.sortSSP });
    });
  }


  changeStatus(item: any) {
    let title;
    let confirmationButtonText;
    if (item.activo) {
      title = "¿Desactivar?";
      confirmationButtonText = "Desactivar";
    } else {
      title = "¿Reactivar?";
      confirmationButtonText = "Reactivar";
    }
    Swal.fire({
      icon: "question",
      title: title,
      text: "Confirmar por favor",
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: confirmationButtonText,
      denyButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        if (item.activo) {
          //si quiso desactivar el item
          this.service.deleteItem(this.serviceName, { id: item.id }).subscribe({
            next: (response: any) => {

              if (response) {
                Swal.fire({
                  title: "Item desactivado",
                  text: "",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 2500,
                });
                this.uploadData.emit(response);
              }
            },

            error: (err) => {
              LOG("Error al desactivar item", err);
            },
          });
        } else {
          //Si quiso reactivar el item
          item.activo = true;
          this.service.updateItem(this.serviceName, item).subscribe({
            next: (response: any) => {
              if (response) {
                Swal.fire({
                  title: "Item reactivado",
                  text: "",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 2500,
                });
                this.uploadData.emit(response.model);
              }
            },

            error: (err) => {
              LOG("Error al reactivar item", err);
            },
          });
        }
      }
    });
  }

  editar(item: any, documentRef: MatButton) {
    if (!!this.edit) {
      this.menuService
        .open(this.edit, documentRef._elementRef, item)
        .afterClosed()
        .subscribe({
          next: (data) => {
            if (data) {
              this.uploadData.emit(data);
            }
          },
        });
    } else {
      this.router.navigateByUrl(this.urlId + item.id);
    }
  }

  ViewLog(item: any) {
    let extra = "";
    if (item) {
      extra = `&[id_row]=${item.id}`;
    }

    this.dialog.open(ViewLogComponent, {
      data: {
        columnsNames: this.headerDef,
        columnsParams: this.matDefs,
        renderType: "ssp",
        sortSSP: "desc",
        endpoint: "log_generals",
        extraParams: `[id_sub_module]=${this.permisos?.id}${extra}`,
        width: "80vw",
      },
    });
  }

  checkType(val: any): any {
    let newVal: any = val;
    if (val == true || val == false) {
      //Si es boolean.
      if (val) {
        newVal = "Si";
      } else {
        newVal = "No";
      }
    } else {
      if (isArray(val)) {
        newVal = "";
        val.forEach((e) => {
          newVal += e.descripcion + ", ";
        });
        newVal = newVal.slice(0, -2);
      }
    }
    return newVal;
  }
}
